import type { OwnerSpace } from "../../services/spaces.service";
import {
  EVENT_FAQ_GROUP_MAX_SPACES,
  EVENT_FAQ_THUMBNAIL_PX,
} from "../constants/host-hub-event-faq.consts";
import type { RecommendedCardItem } from "../types/model/recommended";
import { pickSpaceThumbnailUrl } from "./cloudinary-image.utils";

const toEventFaqItem = ({
  space,
  spaceId,
}: {
  space: OwnerSpace | undefined;
  spaceId: string;
}): RecommendedCardItem => {
  const title = space?.title ?? "";

  return {
    id: spaceId,
    mediaAlt: title,
    mediaUrl: pickSpaceThumbnailUrl({
      images: space?.images,
      size: EVENT_FAQ_THUMBNAIL_PX,
    }),
    primaryCtaRoute: `/your-space/${spaceId}/event-faqs/food_beverage`,
    title,
  };
};

/**
 * Maps space IDs with an incomplete event FAQ into recommended-card rows using
 * owner-space documents (`title`, `images`) from `GET /v1/spaces/owner/:sso-id`.
 * The incomplete IDs arrive sorted by `date_modified` descending; we cap the
 * rendered rows so the next eligible space surfaces once one is completed.
 */
export const toEventFaqItems = ({
  incompleteSpaceIds,
  spaces,
}: {
  incompleteSpaceIds: string[] | undefined;
  spaces: OwnerSpace[] | undefined;
}): RecommendedCardItem[] => {
  const spaceById = new Map((spaces ?? []).map((space) => [space._id, space]));

  return (incompleteSpaceIds ?? [])
    .slice(0, EVENT_FAQ_GROUP_MAX_SPACES)
    .map((spaceId) =>
      toEventFaqItem({
        space: spaceById.get(spaceId),
        spaceId,
      }),
    );
};
